import _ from "lodash";
import * as util from 'util';
import {GeneralService} from '../../../services/generalService';
import {DICTIONARY} from '../../../dictionary';
import {RouteService} from '../../../services/routeService';
import {NotificationService} from '../../../services/notificationService';
import {AuthService} from '../../../services/authService';
import {ENV_CONSTS} from '../../../constants';
import {Component, NgZone, OnInit} from "@angular/core";
import {ClipboardService} from "ngx-clipboard";
import {ActivatedRoute} from "@angular/router";


@Component({
	selector: 'my-plan-component',
	templateUrl: './my-plan.component.html'
})
export class MyPlanComponent implements OnInit {
    dic = DICTIONARY;
    payments = this.gs.payments;
    corpname = this.gs.corpname;
	couponCodeModel = '';
    isLoaded: boolean;
    accountInfo: any;
    showUpgradeOrExpandPlan: boolean;
    sharedPlanInfo: any;
    userInfo: any;
    partner: any;
	prices: any;
	selectedPrice: any;
	showCouponInput = false;
    daysLeftUntilExpiration;
    priceUntilExpiration;
    couponCode = '';
    oneYearAheadOfExpiration;
    isCouponApplied = false;
    currentLicenses: any;
    priceSaved: number;
    amountOfUsersToAdd = 1;
	tabWidth = 130
    upgradePlanMethods = {
		licenses: {display: 'Adjust License Count', value: 'licenses', paypalPaymentType: this.dic.CONSTANTS.paypalPaymentType.extendPlanLicenses},
        oneYear: {display: 'Renew Annual Subscription', value: 'oneYear', paypalPaymentType: this.dic.CONSTANTS.paypalPaymentType.extendPlanExpiration},
    }
    selectedUpgradePlanMethod = this.upgradePlanMethods.oneYear;
	_ = _;
	activeAction = false;
	joinExistingPlanPopup;
	makePaymentPopup;

    random = Math.random().toString(36).replace(/[^a-z]+/g, '').substring(0, 5);
    subscriptions: any = null;
	invoices: any[] = [];
	invoicesLoaded = false;
	cancelSubscriptionPopup: any;
	manageSubscriptionPopup: any;
	billingHistoryPopup: any;
	filteredPricesForPayment: any[] = [];
	cancelFeedbackOptions = [
		{value: 'unused', label: 'No longer need it'},
		{value: 'too_expensive', label: 'Too expensive'},
		{value: 'missing_features', label: 'Missing features'},
		{value: 'switched_service', label: 'Switched to another service'},
		{value: 'too_complex', label: 'Too complex to use'},
		{value: 'customer_service', label: 'Poor customer service'},
		{value: 'other', label: 'Other'},
	];

    constructor(private ngZone:NgZone,
				public gs:GeneralService,
				private authService: AuthService,
				private activatedRoute: ActivatedRoute,
				private rs:RouteService,
				private ns:NotificationService,
				private clipboard: ClipboardService) {
	}

	ngOnInit() {
		let partner = this.activatedRoute.snapshot.paramMap.get('company') || window.history.state.company;

		this.rs.getAccountPlanInfo().then((accountInfo) => {
			this.isLoaded = true;

			this.accountInfo = accountInfo;

			this.showUpgradeOrExpandPlan = (this.accountInfo.user_role === this.dic.CONSTANTS.userRole.admin && this.accountInfo.plan.plan === this.dic.CONSTANTS.planTypePro) || this.accountInfo.plan.plan === this.dic.CONSTANTS.planTypeFree;
			this.currentLicenses = Math.max(this.accountInfo.plan.threat_protection.allowed_users, this.accountInfo.plan.shared_plan.allowed_users);
			if (this.accountInfo.plan.partner_plan_id) {
				this.showUpgradeOrExpandPlan = false;
			}

			this.sharedPlanInfo = accountInfo.plan;

			if (accountInfo.user_role === this.dic.CONSTANTS.userRole.admin || accountInfo.user_role === this.dic.CONSTANTS.userRole.subAdmin) {
				this.accountInfo.plan.newExpiration = new Date(new Date().setFullYear(new Date(this.accountInfo.plan.expired).getFullYear() + 1));
			}
			else {
				// paste key and join to the plan (if not exist already)
				// check if company field is a shared plan key

				if (partner?.length > 60 && !this.sharedPlanInfo.shared_plan.key) {
					this.sharedPlanInfo.shared_plan.key = partner;
					this.joinSharedPlan(partner);
				}
			}

			this.calculateDaysUntilExpiration();
			this.calculatePriceUntilExpiration();
		});

		this.rs.getPricesI().then((response) => {
			this.prices = response.filter(x => x.product.name === 'Trustifi Outbound Shield' && x.recurring);
			this.selectedPrice = this.prices[0];
			this.filteredPricesForPayment = this.prices;
		});

		this.rs.getSubscriptions().then((response) => {
			this.subscriptions = response;

			this.subscriptions.forEach(itm => {
				itm.current_period_end = itm.items.data[0].current_period_end;
			})
		});

		this.rs.getInvoices().then((response) => {
			this.invoices = response;
			this.invoicesLoaded = true;
		});

		this.gs.getUserInfo(false, (userInfo) => {
			this.userInfo = userInfo;
		});

		partner = partner || 'trustifi';

		this.partner = this.dic.PAYPAL_PARTNERS[partner.toLowerCase()];
		if (this.partner) {
			this.partner.id = partner;
		}
	}

    calculateDaysUntilExpiration = () => {
        const today:any = new Date();
        const expirationDate:any = Date.parse(this.accountInfo.plan.expired);

        if (today > expirationDate) {
            this.daysLeftUntilExpiration = 0;
            this.oneYearAheadOfExpiration = (new Date()).setFullYear(new Date().getFullYear() + 1);
        }
        else {
            this.daysLeftUntilExpiration = Math.round(Math.abs((expirationDate - today) / this.dic.CONSTANTS.oneDay));
            let expirationAsDate = new Date(Date.parse(this.accountInfo.plan.expired));
            this.oneYearAheadOfExpiration = expirationAsDate.setFullYear(expirationAsDate.getFullYear() + 1);
        }
    }

    calculatePriceUntilExpiration = () => {
        if (this.daysLeftUntilExpiration > 0) {
            this.priceUntilExpiration = this.accountInfo.plan.proYearlyPrice * this.daysLeftUntilExpiration / 365;
        }
        else {
            this.priceUntilExpiration = this.accountInfo.plan.proYearlyPrice;
        }
    }

    copyKeyToClipboard = () => {
        this.clipboard.copy(this.sharedPlanInfo.shared_plan.key);
        this.ns.showInfoMessage(util.format(this.dic.MESSAGES.copyClipboard, "Key"));
    };

    paymentComplete = (err, res) => {
        if (err) {
            return;
        }

        this.ns.showInfoMessage(this.dic.MESSAGES.planPaymentCompleted);
        setTimeout(() => {
			this.ngZone.run(() => {
				this.refreshPage();
			})
        }, 1500);
    };

	refreshPage = () => {
		window.location.replace(ENV_CONSTS.webAppUrl + this.dic.CONSTANTS.planUrl);
		window.location.reload();
	}

    redirectToCustomerPlan = (isTrustifi=false) => {
        let finalUrl;

        if (isTrustifi) {
            finalUrl = 'https://trustifi.com/get-a-quote/';
        }
        else {
            finalUrl = this.payments.redirectUrl || '';

            if (this.accountInfo) {
                Object.keys(this.accountInfo).forEach((key) => {
                    let toReplace = new RegExp('{{' + key + '}}', 'g');
                    finalUrl = finalUrl.replace(toReplace, this.accountInfo[key]);
                });
            }
        }

        window.open(finalUrl, "_blank");
    };

	leaveSharedPlan = () => {
		this.gs.showPopup({
			title: 'Leave Current Plan',
			subTitle: 'Please note - You are about to leave the plan!',
			body: ['You will not be able to join the plan if the key changes.'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Leave',
			doneCb: () => {
				this.rs.updateUserSharedPlanStatus({action: this.dic.CONSTANTS.planActions.leave}).then((response) => {
					this.ns.showInfoMessage(this.dic.MESSAGES.planLeave);
					this.authService.logout();
				});
			}
		});
	}

    correctFreeUserAmountToAddInput = () => {
        const maxUsers = (this.partner && this.partner.maxUsers) || 20;
        if (this.amountOfUsersToAdd > maxUsers) {
            this.amountOfUsersToAdd = maxUsers;
        }
    }

    applyCoupon = () => {
        if (!this.couponCodeModel) {
            this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Coupon'));
            return;
        }

        this.rs.checkCoupon(this.couponCodeModel).then((newPrice) => {
			this.couponCode = this.couponCodeModel;
            this.isCouponApplied = true;

			if (newPrice?.amount_off) {
				this.priceSaved = newPrice.amount_off;
				this.accountInfo.plan.proYearlyPrice = this.accountInfo.plan.proYearlyPrice - newPrice.amount_off;
			}
			else if (newPrice?.percent_off) {
				this.priceSaved = this.accountInfo.plan.proYearlyPrice * newPrice.percent_off;
				this.accountInfo.plan.proYearlyPrice = this.accountInfo.plan.proYearlyPrice * (1 - newPrice.percent_off);
			}

            this.calculatePriceUntilExpiration();
        });
    }

	openJoinExistingPlanPopup = () => {
		this.joinExistingPlanPopup = {
			key: '',
			loading: false,
			show: true,
			doneCb: () => this.joinSharedPlan(this.joinExistingPlanPopup.key)
		}
	}

	joinSharedPlan = (key) => {
		if (!key || key.length !== 64) {
			this.ns.showErrorMessage(this.dic.ERRORS.invalidKey);
			return;
		}

		if (this.joinExistingPlanPopup) {
			this.joinExistingPlanPopup.loading = true;
		}

		const data = {
			key,
			action: this.dic.CONSTANTS.planActions.join
		};
		this.rs.updateUserSharedPlanStatus(data).then(res => {

			setTimeout(() => {
				this.refreshPage();
			}, 1500);
		}, err => {
			if (this.joinExistingPlanPopup) {
				this.joinExistingPlanPopup.loading = false;
			}
		});
	}

	openMakePaymentPopup = () => {
		if (!this.prices?.length) {
			return;
		}
		this.makePaymentPopup = {
			title: '',
			loading: false,
			show: true,
			doneCb: () => this.joinSharedPlan(this.joinExistingPlanPopup.key)
		}

		this.filteredPricesForPayment = this.prices.filter(x => x.recurring);
		this.selectedPrice = this.filteredPricesForPayment[0];

		if (this.accountInfo.plan.plan === this.dic.CONSTANTS.planTypeFree) {
			this.makePaymentPopup.title = 'Upgrade Plan to Pro';
		}
		else if (this.selectedUpgradePlanMethod === this.upgradePlanMethods.oneYear) {
			this.makePaymentPopup.title = 'Renew Annual Subscription';
			// CC: the license input holds the total license count for the plan - default to the current count
			this.amountOfUsersToAdd = this.currentLicenses || 1;
		}
		else {
			this.makePaymentPopup.title = 'Adjust License Count';
			this.amountOfUsersToAdd = this.currentLicenses || 1;
		}
	}

	openCancelSubscriptionPopup = () => {
		if (!this.subscriptions?.length) {
			return;
		}
		this.cancelSubscriptionPopup = {
			show: true,
			loading: false,
			feedback: 'unused',
			comment: '',
			subscription: this.subscriptions[0],
		};
	}

	confirmCancelSubscription = () => {
		this.cancelSubscriptionPopup.loading = true;
		this.rs.cancelSubscriptions({
			id: this.cancelSubscriptionPopup.subscription.id,
			comment: this.cancelSubscriptionPopup.comment,
			feedback: this.cancelSubscriptionPopup.feedback,
		}).then(() => {
			this.ns.showInfoMessage('Subscription canceled. Access continues until end of billing period.');
			this.subscriptions[0] = {...this.subscriptions[0], cancel_at_period_end: true};
			this.cancelSubscriptionPopup = null;
		}, () => {
			this.cancelSubscriptionPopup.loading = false;
		});
	}

	reactivateSubscription = () => {
		if (!this.subscriptions?.length) {
			return;
		}
		this.rs.reactivateSubscription({ id: this.subscriptions[0].id }).then(() => {
			this.subscriptions[0] = {...this.subscriptions[0], cancel_at_period_end: false};
			this.ns.showInfoMessage('Subscription reactivated — your plan will continue as normal.');
		});
	}

	openManageSubscriptionPopup = () => {
		if (!this.subscriptions?.length) {
			return;
		}
		const sub = this.subscriptions[0];
		this.manageSubscriptionPopup = {
			show: true,
			loading: false,
			subscription: sub,
			currentSeats: sub.items?.data?.[0]?.quantity || 1,
			newSeats: sub.items?.data?.[0]?.quantity || 1,
			previewAmount: null,
			previewLoading: false,
			coupon: null
		};
	}

	previewSeatChange = () => {
		const popup = this.manageSubscriptionPopup;
		if (!popup?.newSeats || popup.newSeats < 1 || popup.newSeats === popup.currentSeats) {
			popup.previewAmount = null;
			return;
		}
		popup.previewLoading = true;
		this.rs.getUpcomingInvoice({
			subscriptionId: popup.subscription.id,
			quantity: popup.newSeats,
			coupon: popup.coupon,
		}).then((invoice) => {
			popup.previewAmount = invoice.amount_due;
			popup.previewLoading = false;
		}, () => {
			popup.previewLoading = false;
		});
	}

	updateSubscriptionSeats = () => {
		if (!this.manageSubscriptionPopup?.newSeats || this.manageSubscriptionPopup.newSeats < 1) {
			this.ns.showErrorMessage('Number of seats must be at least 1');
			return;
		}

		this.manageSubscriptionPopup.loading = true;
		this.rs.updateSubscription({
			subscriptionId: this.manageSubscriptionPopup.subscription.id,
			quantity: this.manageSubscriptionPopup.newSeats,
			coupon: this.manageSubscriptionPopup.coupon
		}).then((updatedSub) => {
			this.subscriptions[0] = updatedSub;
			this.ns.showInfoMessage('Subscription updated successfully.');
			this.manageSubscriptionPopup = null;
		}, () => {
			this.manageSubscriptionPopup.loading = false;
		});
	}

	openCustomerPortal = () => {
		this.rs.createCustomerPortal({returnUrl: window.location.href}).then((response) => {
			window.open(response.url, '_blank');
		});
	}

	openBillingHistoryPopup = () => {
		this.billingHistoryPopup = {show: true};
	}

	get isOneTimePaymentPlan(): boolean {
		return this.accountInfo?.plan?.extended_by_payment === true && !this.subscriptions?.length;
	}

	getCancelFeedbackLabel = () => {
		return this.cancelFeedbackOptions.find(x => x.value === this.cancelSubscriptionPopup?.feedback)?.label || 'Select reason';
	}

	getNextChargeDate = (sub: any): number => {
		const periodEnd = sub.current_period_end * 1000;
		const now = new Date();
		const endDate = new Date(periodEnd);

		// If period end is today or already past, the charge has fired — advance by one interval
		const sameDay = endDate.getFullYear() === now.getFullYear() &&
			endDate.getMonth() === now.getMonth() &&
			endDate.getDate() === now.getDate();

		if (sameDay || periodEnd < now.getTime()) {
			const interval = sub.items?.data?.[0]?.price?.recurring?.interval;
			const count = sub.items?.data?.[0]?.price?.recurring?.interval_count || 1;
			const next = new Date(periodEnd);
			if (interval === 'year')  next.setFullYear(next.getFullYear() + count);
			else if (interval === 'month') next.setMonth(next.getMonth() + count);
			else if (interval === 'week')  next.setDate(next.getDate() + count * 7);
			else if (interval === 'day')   next.setDate(next.getDate() + count);
			return next.getTime();
		}
		return periodEnd;
	}

	getSubscriptionPriceDisplay = (sub: any): string => {
		const item = sub?.items?.data?.[0];
		if (!item?.price?.unit_amount) return '';
		const amount = (item.price.unit_amount / 100).toFixed(2);
		const interval = item.price.recurring?.interval || 'period';
		const seats = item.quantity || 1;
		return `$${amount} × ${seats} seat${seats > 1 ? 's' : ''} / ${interval}`;
	}
}

